<script lang="ts">
  import { page } from "$app/stores";
  import { isStaging } from "$lib/utility/environment";

  export let metaTitle: string | undefined = undefined;
  export let metaDescription: string | undefined = undefined;
  export let canonicalUrl: string;
  export let ogImage: string = "/og.jpg";
  export let ogType: string = "website";
  export let author: string | undefined = undefined;
  export let twitterCard: string = "summary_large_image";
  export let twitterSite: string = "@ChatsheetAI";
  export let noindex: boolean = false;

  $: absoluteCanonicalUrl = canonicalUrl.startsWith("http")
    ? canonicalUrl
    : `${$page.url.origin}${canonicalUrl.startsWith("/") ? "" : "/"}${canonicalUrl}`;

  $: absoluteOgImage = ogImage.startsWith("http")
    ? ogImage
    : `${$page.url.origin}${ogImage.startsWith("/") ? "" : "/"}${ogImage}`;
</script>

<svelte:head>
  <!-- Robot directives -->
  <meta
    name="robots"
    content={noindex || isStaging()
      ? "noindex, nofollow"
      : "max-snippet:-1, max-image-preview:large, max-video-preview:-1"}
  />

  <!-- Basic meta tags -->
  {#if metaTitle}
    <title>{metaTitle}</title>
    <meta name="title" content={metaTitle} />
  {/if}

  {#if metaDescription}
    <meta name="description" content={metaDescription} />
  {/if}

  {#if author}
    <meta name="author" content={author} />
  {/if}

  <!-- Open Graph / Facebook -->
  <meta property="og:type" content={ogType} />
  <meta property="og:url" content={absoluteCanonicalUrl} />

  {#if metaTitle}
    <meta property="og:title" content={metaTitle} />
  {/if}

  {#if metaDescription}
    <meta property="og:description" content={metaDescription} />
  {/if}

  <meta property="og:image" content={absoluteOgImage} />

  {#if author && ogType === "article"}
    <meta property="article:author" content={author} />
  {/if}

  <!-- Twitter -->
  <meta property="twitter:card" content={twitterCard} />
  <meta property="twitter:site" content={twitterSite} />
  <meta property="twitter:url" content={absoluteCanonicalUrl} />

  {#if metaTitle}
    <meta property="twitter:title" content={metaTitle} />
  {/if}

  {#if metaDescription}
    <meta property="twitter:description" content={metaDescription} />
  {/if}

  <meta property="twitter:image" content={absoluteOgImage} />

  <!-- Canonical -->
  <link rel="canonical" href={absoluteCanonicalUrl} />
</svelte:head>
